import { Pipe, PipeTransform } from '@angular/core';
import { EnvironmentKeys } from 'src/environments/environment-keys';

@Pipe({
  name: 'investmentFrequency',
  standalone: false
})
export class InvestmentFrequencyPipe implements PipeTransform {

  public transform(frequency: number | null): string {
    switch (frequency) {
      case 1:
        return EnvironmentKeys.weeklyFrequency;
      case 4:
        return EnvironmentKeys.monthlyFrequency;
      case 12:
        return EnvironmentKeys.quarterlyFrequency;
      default:
        return EnvironmentKeys.unknownFrequency;
    }
  }

}
